import { useAuth } from '@/providers/AuthProvider';
import { Group } from '@mantine/core';
import { ChatButton } from './ChatButton';
import { InfoButton } from './InfoButton';
import { LanguageButton } from './LanguageButton';
import { LoginButton } from './LoginButton';
import { NotificationButton } from './NotificationButton';
import { SearchButton } from './SearchButton';
import { SignupButton } from './SignupButton';
import { TokenBalance } from './TokenBalance';
export const ActionHeader: React.FC = () => {
  const {
    isLogin
  } = useAuth();
  return <Group justify="end" gap={6} mr={8} h={80} wrap="nowrap">
      {isLogin ? <Group gap={8} wrap="nowrap">
          <TokenBalance />
          <InfoButton />
        </Group> : <Group gap={8}>
          <LoginButton />
          <SignupButton />
        </Group>}
      <Group gap={6} visibleFrom="sm">
        {isLogin && <NotificationButton />}
        <SearchButton />
        <LanguageButton />
        <ChatButton />
      </Group>
    </Group>;
};